import React from 'react';
import './Consultation.css';

const Consultation = () => {
  return (
    <section className="consultation-section">
      <div className="consultation-container">
        <h2>Let's talk -</h2>
        <h3>book a Free Consultation</h3>
        <a href="https://calendly.com/genixai-india/30min" className="schedule-button">
          Schedule a call
          <svg viewBox="0 0 24 24" className="arrow-icon">
            <path d="M16.17 13H4v-2h12.17l-5.59-5.59L12 4l8 8-8 8-1.41-1.41L16.17 13z" />
          </svg>
        </a>
      </div>
    </section>
  );
};

export default Consultation; 